import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import css from './CheckoutForm.css';

const DeliverySection = ({ intl, provider }) => {
  const { register, watch, setValue, formState: { errors } } = useFormContext();
  const deliveryType = watch('deliveryType') || 'pickup';
  const isPickup = deliveryType === 'pickup';

  const placeholder = id => intl.formatMessage({ id });

  // Pobieramy punkty odbioru z dostawcy
  const storeOptions = provider?.deliveryToProviders || [];

  return (
    <section className={css.section}>
      <h2 className={css.heading}>
        <FormattedMessage id="DeliverySection.title" defaultValue="Sposób dostawy" />
      </h2>

      <div className={css.typeSwitcher}>
        <button
          type="button"
          className={classNames(css.switchBtn, isPickup && css.switchBtnActive)}
          onClick={() => setValue('deliveryType', 'pickup')}
        >
          <FormattedMessage id="DeliverySection.pickup" defaultValue="Odbiór w sklepie" />
        </button>
        <button
          type="button"
          className={classNames(css.switchBtn, !isPickup && css.switchBtnActive)}
          onClick={() => setValue('deliveryType', 'home')}
        >
          <FormattedMessage id="DeliverySection.home" defaultValue="Dostawa do domu" />
        </button>
      </div>

      <div className={css.invoiceFields}>
        {isPickup ? (
          <div className={classNames(css.field, css.marginBottom)}>
            <label className={css.label}>
              <FormattedMessage id="DeliverySection.selectStore" defaultValue="Wybierz sklep" />
            </label>
            <select
              {...register("delivery.storeId", { required: isPickup })}
              className={errors.delivery?.storeId ? css.inputError : css.input}
              defaultValue=""
            >
              <option value="" disabled>
                {placeholder("DeliverySection.placeholder.selectStore")}
              </option>
              {storeOptions.map(store => (
                <option key={store.id.uuid} value={store.id.uuid}>
                  {store.attributes.name}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div className={css.homeDeliveryContainer}>
            <p className={css.deliveryInfoText}>
              <FormattedMessage
                id="DeliverySection.fedexNotice"
                defaultValue="Dostawa i zwrot produktu odbywa się za pośrednictwem kuriera FEDEX. W przypadku wyboru dostawy do domu zwrot produktu {notPossibleLink} w sklepie stacjonarnym."
                values={{
                  notPossibleLink: (
                    <span className={css.underlineText}>
                      <FormattedMessage id="DeliverySection.notPossible" defaultValue="nie jest możliwy" />
                    </span>
                  )
                }}
              />
            </p>

            <div className={css.field}>
              <label className={css.label}>
                <FormattedMessage id="DeliverySection.postalCodeAndCityLabel" defaultValue="Kod pocztowy oraz miasto*" />
              </label>
              <input
                {...register("delivery.postalCodeAndCity", { required: !isPickup })}
                placeholder={placeholder("DeliverySection.placeholder.postalCodeAndCity") || "Podaj kod pocztowy oraz miasto"}
                className={errors.delivery?.postalCodeAndCity ? css.inputError : css.input}
              />
            </div>

            <div className={css.field}>
              <label className={css.label}>
                <FormattedMessage id="DeliverySection.streetAddressLabel" defaultValue="Ulica, Numer domu / mieszkania*" />
              </label>
              <input
                {...register("delivery.streetAddress", { required: !isPickup })}
                placeholder={placeholder("DeliverySection.placeholder.streetAddress") || "Podaj adres dostawy"}
                className={errors.delivery?.streetAddress ? css.inputError : css.input}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default injectIntl(DeliverySection);